import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ClientDiagnosticsService } from './services/client-diagnostics.service';
import { SessionExpiryService } from './auth/session-expiry.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  constructor(
    private readonly clientDiagnostics: ClientDiagnosticsService,
    private readonly sessionExpiry: SessionExpiryService,
  ) {}

  ngOnInit(): void {
    this.sessionExpiry.initialize();
    this.clientDiagnostics.bootstrap();
  }
}
